module.exports = __webpack_public_path__ + "static/media/forbidden.9828cd7f.svg";